module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff2?6da7830967bc3dc3ada0a89af6b3e5b4";